module.exports = __webpack_public_path__ + "img/spiritcatcher-5.e0878d6d.jpg";